// extracted by mini-css-extract-plugin
export var box = "Subtitle-module--box--5b8d2";
export var box_md = "Subtitle-module--box_md--6cf5a";
export var box_xmd = "Subtitle-module--box_xmd--49eab";
export var box_flex = "Subtitle-module--box_flex--f5811";
export var box_lg = "Subtitle-module--box_lg--9fdc9";
export var box_sm = "Subtitle-module--box_sm--c81ab";
export var box_outer = "Subtitle-module--box_outer--ce43f";
export var box_whiteBg = "Subtitle-module--box_white-bg--1fd99";
export var box_noMarginBottom = "Subtitle-module--box_no-margin-bottom--8015b";
export var box_noPadding = "Subtitle-module--box_no-padding--cba39";
export var box_outerGray = "Subtitle-module--box_outer-gray--f5c1b";
export var box_dark = "Subtitle-module--box_dark--76dc6";
export var box_zIndex = "Subtitle-module--box_z-index--75cd3";
export var box_zIndex6 = "Subtitle-module--box_z-index-6--a9e3f";
export var box_eventsWithLine = "Subtitle-module--box_events-with-line--9066c";
export var box_featuresAo = "Subtitle-module--box_features-ao--c1083";
export var box_verticalPaddings = "Subtitle-module--box_vertical-paddings--862eb";
export var clearP = "Subtitle-module--clearP--8bc5f";
export var clearP_vc = "Subtitle-module--clearP_vc--c3300";
export var subtitle = "Subtitle-module--subtitle--8a569";
export var sm = "Subtitle-module--sm--b1a10";
export var md = "Subtitle-module--md--eb539";
export var lg = "Subtitle-module--lg--e7015";
export var black = "Subtitle-module--black--86835";
export var white = "Subtitle-module--white--50a3e";
export var fadeInAnimation = "Subtitle-module--fadeInAnimation--b2c8a";
export var placeHolderShimmer = "Subtitle-module--placeHolderShimmer--a0d6b";